export default __webpack_public_path__ + "static/SRF 3240ACS50 - Product Specifications & technical data -f0e092808af17a213d99e99f176e60b5.pdf";